module.exports = __webpack_public_path__ + "2580c8195f74f8d4d864222d36f85f52.pdf";